import React from 'react'
import { css, cx } from '@emotion/css'
import { BrowserItem } from './browser-item'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { negativeMargin } from './application-architecture-card'
import { Browser } from './wrapped-browser-bar'
import { FormattedMessage } from 'react-intl'
import { badgeCss } from '../../legacy-design-system/text'

export const browserBarWidth: number = 50

interface BrowserBarProps {
  readonly browsers: Browser[]
}

export function BrowserBar({ browsers }: BrowserBarProps) {
  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
        flex: 1;
        min-width: ${browserBarWidth}px;
        max-width: ${browserBarWidth}px;
        min-width: ${browserBarWidth}px;
        background-color: ${theme.color.neutral50};
        border-radius: 10px;
        align-items: center;
        padding-right: ${negativeMargin}px;
      `}
    >
      <FormattedMessage id={'title_browsers'}>
        {(msg) => {
          return (
            <span
              className={cx(
                badgeCss,
                css`
                  color: ${theme.color.white};
                  flex-wrap: nowrap;
                  writing-mode: vertical-lr;
                  transform: rotate(180deg);
                  margin-top: 15px;
                  margin-bottom: 15px;
                `
              )}
            >
              {msg}
            </span>
          )
        }}
      </FormattedMessage>

      {browsers.map(({ agentName: name, agentVersion: version }, index) => (
        <div
          key={index}
          className={css`
            width: fit-content;
            margin-bottom: 10px;
          `}
        >
          <BrowserItem name={name} version={version} />
        </div>
      ))}
    </div>
  )
}
